// 平台图标映射工具函数
import BinanceIcon from '@/assets/icon/binance_icon.png'
import BitgetIcon from '@/assets/icon/bitget_icon.png'
import GateIcon from '@/assets/icon/gate_icon.png'
import MexcIcon from '@/assets/icon/mexc_icon.png'
import OkxIcon from '@/assets/icon/okx_icon.png'
import XtIcon from '@/assets/icon/xt_icon.png'
import BybitIcon from '@/assets/icon/bybit.png'

/**
 * 根据平台名称获取对应的图标
 * @param {string} platform - 平台名称
 * @returns {string} - 图标路径
 */
export function getPlatformIcon (platform) {
  const iconMap = {
    'okx': OkxIcon,
    'binance': BinanceIcon,
    'mexc': MexcIcon,
    'gate': GateIcon,
    'bitget': BitgetIcon,
    'xt': XtIcon,
    'bybit': BybitIcon
  }

  return iconMap[platform] || ''
}

// 默认导出
export default getPlatformIcon
